import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPaperPlane,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";

export default function InquiryCard() {
  const { getCurrentAgentNumber, getCurrentAgentEmail } = useUserParams();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    setLoading(true);

    try {
      console.log(formData);

      setFormData({
        name: "",
        email: "",
        message: "",
      });

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="overflow-hidden rounded-lg border border-cottage-accent/50  shadow-lg">

      {/* Header */}
      <div className="bg-cottage-secondary px-7 py-8 text-cottage-primary">
        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-cottage-accent/20">
            <FontAwesomeIcon
              icon={faEnvelope}
              className="text-xl text-cottage-accent"
            />
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.35em]">
              Property Inquiry
            </p>

            <h3 className="mt-2 font-serif text-3xl leading-none">
              Contact Agent
            </h3>
          </div>
        </div>

        <p className="mt-5 text-sm leading-6">
          Interested in this property? Send a message and receive detailed
          information from our real estate team.
        </p>
      </div>


      {/* Form */}
      <form
        onSubmit={handleSubmit}
        className="space-y-5 px-7 py-8"
      >
        <div>
          <label className="mb-2 block text-xs uppercase tracking-[0.25em] text-cottage-primary">
            Name
          </label>

          <input
            required
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your name"
            className="
              w-full rounded-lg border border-cottage-accent/50
              px-4 py-3 text-sm text-cottage-primary
              outline-none transition
              focus:border-cottage-accent"
          />
        </div>

        <div>
          <label className="mb-2 block text-xs uppercase tracking-[0.25em] text-cottage-primary">
            Email
          </label>

          <input
            required
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email address"
            className="
              w-full rounded-lg border border-cottage-accent/50
              px-4 py-3 text-sm text-cottage-primary
              outline-none transition
              focus:border-cottage-accent"
          />
        </div>

        <div>
          <label className="mb-2 block text-xs uppercase tracking-[0.25em] text-cottage-primary">
            Message
          </label>

          <textarea
            required
            rows="4"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="I am interested in this property..."
            className="
              w-full rounded-lg border border-cottage-accent/50
              px-4 py-3 text-sm text-cottage-primary
              outline-none transition
              focus:border-cottage-accent"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="
            group btn-cottage w-full
          "
        >
          <FontAwesomeIcon
            icon={faPaperPlane}
            className="transition-transform duration-300 group-hover:translate-x-1 mr-3"
          />
          {loading ? "Sending..." : "Send Inquiry"}
        </button>
      </form>

      {/* Agent Contact */}
      <div className="border-t border-cottage-accent/50 px-7 py-6">
        <p className="text-center text-xs uppercase tracking-[0.3em] text-cottage-muted">
          Prefer Direct Contact?
        </p>

        <div className="mt-4 space-y-3 text-center">
          <p className="flex items-center justify-center gap-2 text-sm text-cottage-primary">
            <FontAwesomeIcon
              icon={faPhone}
              className="text-cottage-accent"
            />
            {getCurrentAgentNumber()}
          </p>

          <p className="flex items-center justify-center gap-2 text-sm text-cottage-primary">
            <FontAwesomeIcon
              icon={faEnvelope}
              className="text-cottage-accent"
            />
            {getCurrentAgentEmail()}
          </p>
        </div>
      </div>
    </div>
  );
}
